
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { StaticTranslationInterface } from '@/types/translations';

@Component({})
export default class Vertalingen extends Vue {
  @Getter('translationKeys', { namespace: 'trans' })
  protected translationKeys!: string[];

  @Getter('translationsByKey', { namespace: 'trans' })
  protected translationsByKey!: (arg0: string) => StaticTranslationInterface[] | undefined;

  protected activeKey: string = '';

  protected activateKey(key: string): void {
    this.activeKey = key;
  }

  protected translationsForActiveKey(): StaticTranslationInterface[] | undefined {
    return this.translationsByKey(this.activeKey);
  }

}
